import type { OpeningHourDefinitionsInDTO } from '@api/ringil-api.v2';

/**
 * RD-3062 — the form of `AddEditRamp` and the ramp body it saves, moved out of the component unchanged so the
 * mapping can be unit-tested. Loading a ramp into the form stays in the component (a chain of setFieldValue calls).
 */

export interface FormData {
  rampName: string;
  isPrivate: boolean;
  openingHourDefinitions: OpeningHourDefinitionsInDTO;
  isShowOnRampDashboard: boolean;
  maxSkuCount?: number;
  maxReservationCount?: number;
  weeklyMaxSkuCount?: number;
  weeklyMaxReservationCount?: number;
  isTemporaryClosed: boolean;
  timezoneId?: string;
}

/** The body both createRampForLocation and updateRampForLocation receive. */
export const rampRequestBody = (values: FormData) => {
  const body = {
    name: values.rampName,
    timeZone: values.timezoneId || 'Europe/Prague',
    isPrivate: values.isPrivate,
    isShowOnRampDashboard: values.isShowOnRampDashboard,
    openingHourDefinitions: values.openingHourDefinitions,
    maxSkuAmount: values.maxSkuCount,
    maxReservationCount: values.maxReservationCount,
    weeklyMaxSkuAmount: values.weeklyMaxSkuCount,
    weeklyMaxReservationCount: values.weeklyMaxReservationCount,
    isTemporaryClosed: values.isTemporaryClosed,
    timezoneId: values.timezoneId,
  };
  return body;
};
